    export const dots1 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots2 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots3 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots4 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots5 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots6 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots7 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots8 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots9 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots10 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots11 = [{}, {}, {}, {}, {}, {}, {}, {}];
    export const dots12 = [{}, {}, {}, {}, {}, {}, {}, {}];

    /* let i = 0;
    dots1.forEach((element, index) => {
      dots1[index].name = ++i;
      dots1[index].filled = false;      
    });

    i = 8;
    dots2.forEach((element, index) => {
      dots2[index].name = ++i;
      dots2[index].filled = false;
    });

    i = 16;
    dots3.forEach((element, index) => {
      dots3[index].name = ++i;
      dots3[index].filled = false;
    });

    i = 24;
    dots4.forEach((element, index) => {
      dots4[index].name = ++i;
      dots4[index].filled = false;
    });

    i = 32;
    dots5.forEach((element, index) => {
      dots5[index].name = ++i;
      dots5[index].filled = false;
    });

    i = 40;
    dots6.forEach((element, index) => {
      dots6[index].name = ++i;
      dots6[index].filled = false;
    });

    i = 48;
    dots7.forEach((element, index) => {
      dots7[index].name = ++i;
      dots7[index].filled = false;
    });

    i = 56;
    dots8.forEach((element, index) => {
      dots8[index].name = ++i;
      dots8[index].filled = false;
    });

    i = 64;
    dots9.forEach((element, index) => {
      dots9[index].name = ++i;
      dots9[index].filled = false;
    });

    i = 72;
    dots10.forEach((element, index) => {
      dots10[index].name = ++i;
      dots10[index].filled = false;
    });

    i = 80;
    dots11.forEach((element, index) => {
      dots11[index].name = ++i;
      dots11[index].filled = false;

    i = 88;
    dots12.forEach((element, index) => {
      dots12[index].name = ++i;
      dots12[index].filled = false;
    }); */

    export const dotsAll = [{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {},{}, {}, {}, {}, {}, {}, {}, {}];
    //export const dotsAll = dots1; //.concat(dots2, dots3, dots4, dots5, dots6, dots7, dots8, dots9, dots10, dots11, dots12); 
    // export const dotsAll = new Array(96);

    export const arrPurple = new Array(8).fill('purple');
    export const arrMagenta = new Array(8).fill('magenta');
    export const arrScarlet = new Array(8).fill('scarlet');
    export const arrRed = new Array(8).fill('red');
    export const arrOrange = new Array(8).fill('orange');
    export const arrYellow = new Array(8).fill('yellow');
    export const arrLemon = new Array(8).fill('lemon');
    export const arrGreen = new Array(8).fill('green');
    export const arrTurqoise = new Array(8).fill('turquoise');
    export const arrCyan = new Array(8).fill('cyan');
    export const arrIndigo = new Array(8).fill('indigo');
    export const arrBlue = new Array(8).fill('blue');

    export const arrColors = arrPurple.concat(arrMagenta, arrScarlet, arrRed, arrOrange, arrYellow, arrLemon, arrGreen, arrTurqoise, arrCyan, arrIndigo, arrBlue);

    export const arrColorsTest = arrPurple.concat(arrMagenta, arrScarlet, arrRed, arrOrange, arrYellow, arrLemon, arrGreen, arrTurqoise, arrCyan, arrIndigo, arrBlue);
    /* export const arrPurple = new Array(8).fill('#7d00ff');
    export const arrMagenta = new Array(8).fill('#ff00ff');
    export const arrScarlet = new Array(8).fill('#ff007d');
    export const arrRed = new Array(8).fill('#ff0000');
    export const arrOrange = new Array(8).fill('#ff7d00');
    export const arrYellow = new Array(8).fill('#ffff00');
    export const arrLemon = new Array(8).fill('#7dff00');
    export const arrGreen = new Array(8).fill('#00ff00');
    export const arrTurqoise = new Array(8).fill('#00ff7d');
    export const arrCyan = new Array(8).fill('#00ffff');
    export const arrIndigo = new Array(8).fill('#007dff');
    export const arrBlue = new Array(8).fill('#0000ff');   */
    